export enum INBOX_LIST_TYPE {
    MY_TASK = 'myTasks',
    TEAM_TASK = 'teamTasks',
    GROUP_TASK = 'groupTasks',
    ENQUIRY = 'enquiry',
    TASKS = 'tasks',
    SIGNALS = 'signals',
    RECOVERY = 'recovery',
}

// 2️⃣ Inbox Types (relations) per inbox
export enum InboxRelation {
    // inbox
    MY_TASKS = 'myTasks',
    GROUP_TASKS = 'groupTasks',
    TEAM_TASKS = 'teamTasks',

    // admin_inbox
    TASKS = 'tasks',
    SIGNALS = 'signals',
    RECOVERY = 'recovery',

    // enquiry_inbox — intentionally same value as TASKS; scoped by InboxName
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    ENQUIRY_TASKS = 'tasks',
}

export const INBOX_CONFIG: Record<INBOX_LIST_TYPE, { label: string; path: InboxRelation; lang: string }> = {
    [INBOX_LIST_TYPE.MY_TASK]: { label: 'My Task', path: InboxRelation.MY_TASKS, lang: 'default-cm-myTasks' },
    [INBOX_LIST_TYPE.GROUP_TASK]: {
        label: 'Group Task',
        path: InboxRelation.GROUP_TASKS,
        lang: 'default-cm-groupTasks',
    },
    [INBOX_LIST_TYPE.TEAM_TASK]: { label: 'Team Task', path: InboxRelation.TEAM_TASKS, lang: 'default-cm-teamTasks' },
    [INBOX_LIST_TYPE.ENQUIRY]: { label: 'Enquiry', path: InboxRelation.ENQUIRY_TASKS, lang: 'default-cm-enquiry' },
    [INBOX_LIST_TYPE.TASKS]: { label: 'Tasks', path: InboxRelation.TASKS, lang: 'default-cm-tasks' },
    [INBOX_LIST_TYPE.SIGNALS]: { label: 'Signals', path: InboxRelation.SIGNALS, lang: 'default-cm-signals' },
    [INBOX_LIST_TYPE.RECOVERY]: { label: 'Recovery', path: InboxRelation.RECOVERY, lang: 'default-cm-re-attempt' },
} as const;

export interface Group {
    groupName: string;
    id: number;
}

export interface User {
    userName: string;
    id: number;
}
export interface AdminFilter {
    filterId: string;
    filterName: string;
    description: string;
    inboxListType: string;
    groups: Group[];
    users: User[];
    filters: Record<string, string>;
    additionalFilters: Record<string, string>;
    metadata: { createdAt: Date; updatedAt: Date };
}

export interface ICreateFilter extends Omit<AdminFilter, 'metadata' | 'filterName'> {
    name: string;
}
export interface FetchAdminFilterById extends AdminFilter {
    projectId: string;
}

export enum InboxFilterType {
    ADMIN_FILTER = 'ADMIN_FILTER',
}

export interface ListAdminFilters {
    records: AdminFilter[];
    total: number;
}

export interface UserListRespone {
    id: number;
    user_id: string;
    username: string;
}

export interface IinboxFilter {
    filters: Filters[];
    isFilterVisible: boolean;
}

export const INBOX_TYPES = [INBOX_LIST_TYPE.MY_TASK, INBOX_LIST_TYPE.GROUP_TASK, INBOX_LIST_TYPE.TEAM_TASK];
export const ADMIN_INBOX_TYPES = [INBOX_LIST_TYPE.TASKS, INBOX_LIST_TYPE.SIGNALS, INBOX_LIST_TYPE.RECOVERY];
export const ENQIORY_INBOX_TYPES = [INBOX_LIST_TYPE.ENQUIRY];

export interface INBOX_RESPONSE {
    [INBOX_LIST_TYPE.MY_TASK]: IinboxFilter;
    [INBOX_LIST_TYPE.GROUP_TASK]: IinboxFilter;
    [INBOX_LIST_TYPE.TEAM_TASK]: IinboxFilter;
}

export interface ADMIN_INBOX_RESPONSE {
    [INBOX_LIST_TYPE.TASKS]: IinboxFilter;
    [INBOX_LIST_TYPE.SIGNALS]: IinboxFilter;
    [INBOX_LIST_TYPE.RECOVERY]: IinboxFilter;
}

export interface ENQUIRY_INBOX_RESPONSE {
    [INBOX_LIST_TYPE.ENQUIRY]: IinboxFilter;
}

export interface Filters {
    filterName: string;
    fields: FilterField[];
}

export interface FilterField {
    name: string;
    label: string;
    mapping: string;
    mappingType: string;
    type: 'number-range' | 'search' | 'date-range' | string;
    filterOptions: FilterOptions;
    langValue: string;
}

export interface FilterOptions {
    _exactMatch: boolean;
    type: 'number-range' | 'search' | 'date-range' | string;
    label: string;
    minLabel: string | null;
    maxLabel: string | null;
    labelType: string | null;
    dateFormat: string; // only for date-range
    options: any[] | null;
}
interface CONFIGS {
    name: string;
    default: boolean;
    filterObject?: any;
    type?: InboxFilterType;
    filterId?: string;
}

export interface INBOX_CONFIGS extends CONFIGS {
    key: 'myTasks' | 'teamTasks' | 'groupTasks';
}

export interface ENQUIRY_INBOX_CONFIGS extends CONFIGS {
    key: 'enquiry';
}

export interface ADMIN_INBOX_CONFIGS extends CONFIGS {
    key: 'tasks' | 'signals' | 'recovery';
}

// 1️⃣ Inbox Names
export enum InboxName {
    INBOX = 'inbox',
    ADMIN = 'admin_inbox',
    ENQUIRY = 'enquiry_inbox',
}

export const INBOX_NAME_LABEL = {
    [InboxName.INBOX]: 'Inbox',
    [InboxName.ADMIN]: 'Admin',
    [InboxName.ENQUIRY]: 'Enquiry',
};

export enum InboxAttributes {
    IS_FILTER_VISIBLE = 'isFilterVisible',
    FILTERS = 'filters',
}

export enum InboxListType {
    INBOX = 'inbox-list',
    ENQUIRY = 'enquiry-list',
}
